import { render, staticRenderFns } from "./MaterialDashboard.vue?vue&type=template&id=b64076e6&scoped=true&"
import script from "./MaterialDashboard.vue?vue&type=script&lang=js&"
export * from "./MaterialDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDashboard.vue?vue&type=style&index=0&id=b64076e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64076e6",
  null
  
)

export default component.exports